import { jsx as _jsx } from "react/jsx-runtime";
const PromptLibraryHeader = () => {
    return (_jsx("div", { className: "flex gap-2 h-14 items-center pl-6 pr-3 py-3 border-b border-gray-300 bg-white", children: _jsx("div", { className: "flex flex-1 gap-2 h-8 items-center", children: _jsx("h1", { className: "flex-1 font-sans font-bold leading-[1.2] text-[19px] text-gray-900 m-0", children: "Prompt Library" }) }) }));
};
export default PromptLibraryHeader;
